import { gql } from '@lcs/shared/api';

export const deleteAllowedIpMutation = gql`
   mutation DeleteAllowedIp($allowedIpAddressId: UInt!) {
      deleteAllowedIpAddress(id: $allowedIpAddressId)
   }
`;
